import type { PropsWithChildren, ReactNode } from "react"

export function PageSection({
  title,
  actions,
  children,
  className = "",
}: PropsWithChildren<{ title: string; actions?: ReactNode; className?: string }>) {
  return (
    <section className={`bg-white rounded-lg shadow-sm border border-slate-200 p-6 ${className}`}>
      <div className="flex items-center justify-between gap-3 mb-4">
        <h2 className="font-bold text-slate-800">{title}</h2>
        {actions}
      </div>
      {children}
    </section>
  )
}
